const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

const csvmaker = function (data) {
    const csvRows = [];
    const headers = Object.keys(data[0]);
    csvRows.push(headers.join(','));

    data.forEach(obj => {
        const values = headers.map(header => obj[header]).join(',');
        csvRows.push(values);
    });

    return csvRows.join('\n');
}

const  trimMultipleSpacesToSingle = (inputString) => {
    if(inputString)
        return inputString.replace(/\s+/g, ' ').trim();
    else return inputString
}

// index is the position in the already-filtered (ENABLED, non-LOCATION/CAROUSEL) list.
const mapTemplate = (template, index) => {
    const cards = [];
    if (Array.isArray(template?.carouselCards)) {
        template.carouselCards.forEach((card) => {
            const comp = {};
            if (Array.isArray(card.components)) {
                card.components.forEach((component) => {
                    switch (component?.type) {
                        case "header":
                            comp.headerType = component?.format;
                            break;
                        case "body":
                            comp.body = component?.text || "";
                            break;
                        case "buttons":
                            comp.buttons = component?.buttons;
                            break;
                        default:
                            break;
                    }
                });
            }
            cards.push(comp);
        });
    }
    return {
        label: template.name,
        value: index + 1,
        details: {
            ...template,
            containerMeta: {
                ...template,
                data: template?.body,
                cards,
                // Enterprise's list API returns this as the STRING "true" (ce-api
                // MessageTemplateService.java:2797-2799), not a real boolean — WhatsAppPreview.js
                // reads containerMeta.isCPR (a real boolean) to swap in the Call Permission
                // Request panel, same field Form/index.js's own buildPreviewTemplate sets from
                // form state.
                isCPR: String(template?.call_permission_request).toLowerCase() === 'true',
            },
            templateType: template?.button_type === "CAROUSEL" ? template?.button_type : template?.type,
            data: template?.body,
        },
    };
}

export {
    formatDate,
    csvmaker,
    trimMultipleSpacesToSingle,
    mapTemplate,
}
